import { render, staticRenderFns } from "./Evidences.vue?vue&type=template&id=8372b5d8&"
import script from "./Evidences.vue?vue&type=script&lang=js&"
export * from "./Evidences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports